import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";

const definir = (thisStore, data) => {
    thisStore.dispatch(DEFINIR_BREADCRUMB, data);
}

export default {
    definir
}